import {ColorType} from '../types';
import {Section, Title, Label, ToggleGroupContent, ToggleGroupItem, ToggleGroupRoot} from '../../index.styled';

interface Props {
	disabled?: boolean;
	onChange: (value: ColorType) => void;
	value: ColorType;
}

export function ColorSelectorControl(props: Props) {
	const {disabled, onChange, value} = props;

	return (
		<Section>
			<Title size='small' font='mono' color='neutral64'>Output</Title>
			<ToggleGroupRoot
				value={value}
				disabled={disabled}
			>
				<ToggleGroupContent>
					<ToggleGroupItem
						value={ColorType.Colored}
						onClick={() => onChange(ColorType.Colored)}
					>
						<Label size='medium' bold>Color</Label>
					</ToggleGroupItem>
					<ToggleGroupItem
						value={ColorType.BlackAndWhite}
						onClick={() => onChange(ColorType.BlackAndWhite)}
					>
						<Label size='medium' bold>Black & White</Label>
					</ToggleGroupItem>
				</ToggleGroupContent>
			</ToggleGroupRoot>
		</Section>
	);
}
